export const translations = {
  id: {
    nav: {
      home: "Beranda",
      about: "Profil",
      about_overview: "Tentang Kami",
      struktur_organisasi: "Struktur Organisasi",
      sejarah: "Sejarah",
      services: "Layanan",
      doctors: "Dokter",
      news: "Berita",
      gallery: "Galeri",
      contact: "Kontak",
      appointment: "Buat Janji Temu",
      laporan: "Laporan",
      laporan_pmkp: "PMKP",
      laporan_rj: "10 Besar Penyakit Rawat Jalan",
      laporan_ri: "10 Besar Penyakit Rawat Inap",
      laporan_kunjungan: "Kunjungan Pasien",
      analisis: "Analisis",
      analisis_kunjungan: "Kunjungan Pasien",
      analisis_bor: "BOR (Bed Occupancy Ratio)",
      analisis_pegawai: "Rekapitulasi Pegawai",
      analisis_lab: "Laboratorium",
      analisis_radiologi: "Radiologi",
      analisis_apotek: "Apotek",
      siperkasa: "SIPERKASA",
    },
    header: {
      tagline: "Melayani dengan Sepenuh Hati",
    },
    hero: {
      badge: "Kepercayaan • Profesional • Peduli",
      title_line1: "Kesehatan Anda,",
      title_line2: "Prioritas Kami",
      subtitle:
        "RS Bhayangkara Tarakan hadir dengan tim medis bersertifikat dan fasilitas modern untuk memberikan pelayanan kesehatan terbaik bagi masyarakat Kalimantan Utara.",
      cta_primary: "Buat Janji via WhatsApp",
      cta_secondary: "Lihat Layanan Kami",
      stats: {
        doctors: "Dokter Spesialis",
        services: "Layanan Medis",
        emergency: "IGD Siaga",
        experience: "Tahun Pengalaman",
      },
    },
    about: {
      overline: "Tentang Kami",
      title: "Rumah Sakit Terpercaya di Tarakan",
      p1: "RS Bhayangkara Tarakan adalah rumah sakit yang berada di bawah naungan Polda Kalimantan Utara. Kami berkomitmen memberikan pelayanan kesehatan profesional, terjangkau, dan berkualitas kepada seluruh anggota Polri, keluarga, serta masyarakat umum.",
      p2: "Dengan tim dokter spesialis bersertifikat dan fasilitas medis modern, kami senantiasa hadir dengan pelayanan yang mengutamakan keselamatan dan kenyamanan pasien.",
      vision_label: "Visi",
      vision: "Menjadi rumah sakit pilihan utama masyarakat Kalimantan Utara dengan pelayanan prima dan profesional.",
      mission_label: "Misi",
      mission: "Memberikan pelayanan medis yang aman, ramah, dan berorientasi pada kepuasan pasien dengan standar mutu terbaik.",
      values_label: "Nilai",
      values: "Integritas, empati, profesionalisme, dan pelayanan tulus untuk setiap pasien yang datang.",
    },
    services: {
      overline: "Layanan Kami",
      title: "Pelayanan Kesehatan Lengkap",
      subtitle: "Beragam layanan medis untuk memenuhi kebutuhan kesehatan Anda dan keluarga.",
    },
    doctors: {
      overline: "Tim Medis",
      title: "Dokter Bersertifikat & Berpengalaman",
      subtitle: "Tim dokter spesialis kami siap memberikan pelayanan terbaik dengan kompetensi tinggi.",
      schedule: "Jadwal Praktik",
      book: "Buat Janji",
    },
    news: {
      overline: "Informasi Kesehatan",
      title: "Berita & Artikel Terbaru",
      subtitle: "Ikuti update terbaru seputar kesehatan dan kegiatan rumah sakit.",
      read_more: "Baca Selengkapnya",
    },
    gallery: {
      overline: "Galeri",
      title: "Fasilitas & Momen Kami",
      subtitle: "Lihat lebih dekat fasilitas modern dan suasana rumah sakit kami.",
    },
    contact: {
      overline: "Hubungi Kami",
      title: "Kami Selalu Siap Membantu",
      subtitle: "Untuk pertanyaan, konsultasi, atau membuat janji temu, silakan hubungi kami melalui kanal berikut.",
      address_label: "Alamat",
      phone_label: "Telepon / WhatsApp",
      email_label: "Email",
      hours_label: "Jam Layanan",
      form_title: "Kirim Pesan",
      form_subtitle: "Isi form di bawah dan tim kami akan menghubungi Anda.",
      form_name: "Nama Lengkap",
      form_email: "Email",
      form_phone: "Nomor Telepon",
      form_subject: "Subjek",
      form_message: "Pesan Anda",
      form_submit: "Kirim Pesan",
      form_success: "Pesan berhasil terkirim. Kami akan segera menghubungi Anda.",
      form_error: "Terjadi kesalahan. Silakan coba lagi.",
    },
    footer: {
      about: "Rumah sakit terpercaya di Tarakan, Kalimantan Utara, melayani masyarakat dengan standar profesional di bawah naungan Polda Kalimantan Utara.",
      quick_links: "Tautan Cepat",
      services_links: "Layanan",
      contact_us: "Hubungi Kami",
      rights: "Seluruh hak cipta dilindungi.",
      follow_us: "Ikuti Kami",
      follow_ig: "Ikuti Instagram",
    },
    common: {
      loading: "Memuat...",
      switch_lang: "EN",
    },
    laporan: {
      overline: "Transparansi & Akuntabilitas",
      title: "Laporan Rumah Sakit",
      subtitle:
        "Ringkasan data mutu pelayanan, penyakit terbanyak, dan kunjungan pasien RS Bhayangkara Tarakan.",
      pmkp_title: "PMKP",
      pmkp_desc: "Peningkatan Mutu & Keselamatan Pasien",
      rj_title: "10 Besar Penyakit Rawat Jalan",
      rj_desc: "Peringkat penyakit dengan kunjungan poliklinik tertinggi.",
      ri_title: "10 Besar Penyakit Rawat Inap",
      ri_desc: "Peringkat diagnosis pasien rawat inap terbanyak.",
      kunjungan_title: "Kunjungan Pasien",
      kunjungan_desc: "Statistik kunjungan IGD, rawat jalan, rawat inap, dan MCU.",
      select_period: "Pilih Periode",
      download_pdf: "Unduh PDF",
      no_pdf: "PDF belum tersedia",
      empty: "Belum ada data laporan.",
      view_report: "Lihat Laporan",
      back_to_reports: "Kembali ke Laporan",
      period: "Periode",
      total_visits: "Total Kunjungan",
      indicator: "Indikator",
      target: "Target",
      actual: "Realisasi",
      status_met: "Tercapai",
      status_below: "Belum tercapai",
      insiden_title: "Insiden Keselamatan Pasien",
      insiden_ikp: "IKP",
      insiden_knc: "KNC",
      insiden_ktd: "KTD",
      insiden_sentinel: "Sentinel",
      rank: "Peringkat",
      icd: "Kode ICD-10",
      disease: "Diagnosis",
      cases: "Jumlah Kasus",
      total: "Total",
      igd: "IGD",
      poli: "Rawat Jalan",
      inap: "Rawat Inap",
      mcu: "Medical Check-Up",
      // Analisis (protected)
      analisis_overline: "Area Terbatas • Login",
      analisis_title: "Analisis Data",
      analisis_subtitle:
        "Analisis mendalam untuk manajemen rumah sakit. Membutuhkan login admin.",
      analisis_kunjungan_title: "Kunjungan Pasien — Analisis",
      analisis_kunjungan_desc: "Breakdown per poli, pola harian, dan pertumbuhan tahunan (YoY).",
      analisis_bor_title: "BOR — Bed Occupancy Ratio",
      analisis_bor_desc: "Indikator baku Kemenkes: BOR, LOS, TOI, BTO dengan target & realisasi.",
      analisis_pegawai_title: "Rekapitulasi Pegawai",
      analisis_pegawai_desc: "Komposisi SDM: status kepegawaian (PNS/PPPK/Kontrak), tenaga medis vs non-medis, dan sebaran per unit.",
      siperkasa_overline: "SIPERKASA • Area Terbatas",
      siperkasa_title: "Sistem Informasi Pengukuran Kinerja Rumah Sakit",
      siperkasa_subtitle:
        "Meningkatkan efektivitas monitoring & evaluasi kinerja RS Bhayangkara Tingkat IV Tarakan melalui pemantauan capaian indikator seluruh unit kerja secara terintegrasi.",
      siperkasa_sources: "Sumber Data Kinerja",
      siperkasa_penunjang: "Fasilitas Penunjang",
      analisis_lab_title: "Laboratorium — Kunjungan",
      analisis_lab_desc: "Jumlah pemeriksaan laboratorium per jenis (hematologi, kimia klinik, mikrobiologi, dll).",
      analisis_radiologi_title: "Radiologi — Kunjungan",
      analisis_radiologi_desc: "Jumlah pemeriksaan radiologi per modalitas (X-Ray, USG, CT-Scan, EKG).",
      analisis_apotek_title: "Apotek — Kunjungan & Obat",
      analisis_apotek_desc: "Jumlah lembar resep per unit layanan dan rekapitulasi penggunaan obat.",
      apotek_resep_total: "Total Lembar Resep",
      apotek_resep_breakdown: "Resep per Unit Layanan",
      apotek_obat_title: "Rekapitulasi Penggunaan Obat",
      apotek_obat_total: "Total Item Obat Keluar",
      apotek_obat_top: "10 Obat Terbanyak Digunakan",
      apotek_obat_kategori: "Komposisi Kategori Obat",
      penunjang_breakdown: "Rincian Pemeriksaan",
      siperkasa_pegawai_total: "Total Pegawai",
      siperkasa_by_status: "Komposisi Status Kepegawaian",
      siperkasa_by_type: "Tenaga Medis vs Non-Medis",
      siperkasa_by_unit: "Sebaran Pegawai per Unit",
      siperkasa_by_gender: "Komposisi Jenis Kelamin",
      siperkasa_headcount_trend: "Tren Jumlah Pegawai",
      analisis_locked: "Silakan login untuk mengakses analisis",
      analisis_login_cta: "Login Admin",
      breakdown_poli: "Kunjungan per Poli",
      breakdown_ralan: "Kunjungan Rawat Jalan per Poliklinik",
      breakdown_ranap: "Kunjungan Rawat Inap per Bangsal",
      pasien_baru: "Baru",
      pasien_lama: "Lama",
      pasien: "pasien",
      rasio_baru_lama: "Rasio Pasien Baru vs Lama",
      rasio_baru_lama_desc: "Indikator pertumbuhan pasien rawat jalan",
      ralan_table_title: "Rincian Rawat Jalan per Poliklinik",
      col_poli: "Poliklinik",
      trend_baru_title: "Tren Persentase Pasien Baru",
      trend_ranap_title: "Tren Hunian Rawat Inap per Bangsal",
      bor_bangsal_title: "BOR per Bangsal (Bulan Ini)",
      bor_bangsal_top: "Terpadat",
      bor_bangsal_hint: "Hijau = dalam target, kuning = di bawah, merah = di atas target Kemenkes",
      bor_bangsal_trend_title: "Tren BOR per Bangsal",
      top_poli_badge: "Tertinggi",
      top_poli_label: "Poliklinik dengan proporsi pasien baru tertinggi",
      top_bangsal_label: "Bangsal dengan proporsi pasien baru tertinggi",
      rasio_baru_ranap: "Rasio Pasien Baru Rawat Inap",
      rasio_baru_ranap_desc: "Indikator pertumbuhan pasien rawat inap",
      total_ralan: "Total Rawat Jalan",
      total_ranap: "Total Rawat Inap",
      weekday_pattern: "Pola Kunjungan Harian",
      yoy_growth: "Pertumbuhan YoY",
      last_year: "Tahun Lalu",
      this_year: "Tahun Ini",
      bor_indicator: "Indikator BOR",
      admissions: "Admisi",
      discharges: "Pulang",
      deaths: "Kematian",
      beds_total: "Total Tempat Tidur",
      target_range: "Rentang Target",
      ind_bor_desc: "Efisiensi pemakaian tempat tidur",
      ind_los_desc: "Rata-rata lama hari rawat pasien",
      ind_toi_desc: "Rata-rata hari tempat tidur kosong antar pasien",
      ind_bto_desc: "Frekuensi pemakaian satu tempat tidur",
      status_above: "Di atas target",
      status_under: "Di bawah target",
      mutu_title: "Kartu Mutu — Angka Kematian",
      mutu_ndr: "NDR (Net Death Rate)",
      mutu_gdr: "GDR (Gross Death Rate)",
      mutu_ndr_desc: "Kematian ≥ 48 jam per 1.000 pasien keluar",
      mutu_gdr_desc: "Total kematian per 1.000 pasien keluar",
      mutu_target: "Target Kemenkes",
      mutu_no_data: "Data pasien keluar belum tersedia",
      mutu_deaths_total: "Total kematian",
    },
  },
  en: {
    nav: {
      home: "Home",
      about: "About",
      about_overview: "About Us",
      struktur_organisasi: "Organizational Structure",
      sejarah: "History",
      services: "Services",
      doctors: "Doctors",
      news: "News",
      gallery: "Gallery",
      contact: "Contact",
      appointment: "Book Appointment",
      laporan: "Reports",
      laporan_pmkp: "PMKP",
      laporan_rj: "Top 10 Outpatient Diseases",
      laporan_ri: "Top 10 Inpatient Diseases",
      laporan_kunjungan: "Patient Visits",
      analisis: "Analytics",
      analisis_kunjungan: "Patient Visits",
      analisis_bor: "BOR (Bed Occupancy Ratio)",
      analisis_pegawai: "Employee Recap",
      analisis_lab: "Laboratory",
      analisis_radiologi: "Radiology",
      analisis_apotek: "Pharmacy",
      siperkasa: "SIPERKASA",
    },
    header: {
      tagline: "Serving with Heart",
    },
    hero: {
      badge: "Trust • Professional • Caring",
      title_line1: "Your Health, ",
      title_line2: "Our Priority",
      subtitle:
        "RS Bhayangkara Tarakan brings a board-certified medical team and modern facilities to deliver the best healthcare services for North Kalimantan communities.",
      cta_primary: "Book via WhatsApp",
      cta_secondary: "Explore Our Services",
      stats: {
        doctors: "Specialist Doctors",
        services: "Medical Services",
        emergency: "ER Standby",
        experience: "Years of Experience",
      },
    },
    about: {
      overline: "About Us",
      title: "A Trusted Hospital in Tarakan",
      p1: "RS Bhayangkara Tarakan is a hospital operating under North Kalimantan Police (Polda Kaltara). We are committed to delivering professional, affordable, and quality healthcare for all Polri members, their families, and the general public.",
      p2: "With board-certified specialist doctors and modern medical facilities, we consistently prioritize patient safety and comfort in every service we provide.",
      vision_label: "Vision",
      vision: "To become the preferred hospital in North Kalimantan with exceptional and professional services.",
      mission_label: "Mission",
      mission: "To deliver safe, friendly, patient-focused medical services with the highest quality standards.",
      values_label: "Values",
      values: "Integrity, empathy, professionalism, and sincere service for every patient who arrives.",
    },
    services: {
      overline: "Our Services",
      title: "Comprehensive Healthcare Services",
      subtitle: "A wide range of medical services to meet the health needs of you and your family.",
    },
    doctors: {
      overline: "Medical Team",
      title: "Board-Certified & Experienced Doctors",
      subtitle: "Our specialist doctors are ready to provide top-notch care with high competence.",
      schedule: "Practice Schedule",
      book: "Book Now",
    },
    news: {
      overline: "Health Information",
      title: "Latest News & Articles",
      subtitle: "Stay updated with the latest health news and hospital activities.",
      read_more: "Read More",
    },
    gallery: {
      overline: "Gallery",
      title: "Our Facilities & Moments",
      subtitle: "Take a closer look at our modern facilities and hospital atmosphere.",
    },
    contact: {
      overline: "Get in Touch",
      title: "We Are Always Ready to Help",
      subtitle: "For questions, consultations, or appointments, please contact us through the channels below.",
      address_label: "Address",
      phone_label: "Phone / WhatsApp",
      email_label: "Email",
      hours_label: "Service Hours",
      form_title: "Send Us a Message",
      form_subtitle: "Fill out the form below and our team will reach out.",
      form_name: "Full Name",
      form_email: "Email",
      form_phone: "Phone Number",
      form_subject: "Subject",
      form_message: "Your Message",
      form_submit: "Send Message",
      form_success: "Message sent successfully. We'll be in touch shortly.",
      form_error: "Something went wrong. Please try again.",
    },
    footer: {
      about: "A trusted hospital in Tarakan, North Kalimantan, serving the community with professional standards under North Kalimantan Police.",
      quick_links: "Quick Links",
      services_links: "Services",
      contact_us: "Contact Us",
      rights: "All rights reserved.",
      follow_us: "Follow Us",
      follow_ig: "Follow on Instagram",
    },
    common: {
      loading: "Loading...",
      switch_lang: "ID",
    },
    laporan: {
      overline: "Transparency & Accountability",
      title: "Hospital Reports",
      subtitle:
        "Summary of quality metrics, most-common diseases, and patient visit statistics at RS Bhayangkara Tarakan.",
      pmkp_title: "PMKP",
      pmkp_desc: "Quality Improvement & Patient Safety",
      rj_title: "Top 10 Outpatient Diseases",
      rj_desc: "Diagnoses with the highest outpatient visits.",
      ri_title: "Top 10 Inpatient Diseases",
      ri_desc: "Most-common inpatient admission diagnoses.",
      kunjungan_title: "Patient Visits",
      kunjungan_desc: "Statistics of ER, outpatient, inpatient and MCU visits.",
      select_period: "Select Period",
      download_pdf: "Download PDF",
      no_pdf: "PDF not available yet",
      empty: "No report data yet.",
      view_report: "View Report",
      back_to_reports: "Back to Reports",
      period: "Period",
      total_visits: "Total Visits",
      indicator: "Indicator",
      target: "Target",
      actual: "Actual",
      status_met: "Met",
      status_below: "Below target",
      insiden_title: "Patient Safety Incidents",
      insiden_ikp: "PSI",
      insiden_knc: "Near-miss",
      insiden_ktd: "Adverse event",
      insiden_sentinel: "Sentinel",
      rank: "Rank",
      icd: "ICD-10 Code",
      disease: "Diagnosis",
      cases: "Cases",
      total: "Total",
      igd: "ER",
      poli: "Outpatient",
      inap: "Inpatient",
      mcu: "Medical Check-Up",
      // Analytics (protected)
      analisis_overline: "Restricted Area • Login Required",
      analisis_title: "Data Analytics",
      analisis_subtitle:
        "In-depth analytics for hospital management. Admin login required.",
      analisis_kunjungan_title: "Patient Visits — Analytics",
      analisis_kunjungan_desc: "Breakdown by clinic, weekday pattern, and year-over-year growth.",
      analisis_bor_title: "BOR — Bed Occupancy Ratio",
      analisis_bor_desc: "Ministry of Health standard: BOR, LOS, TOI, BTO with targets & actuals.",
      analisis_pegawai_title: "Employee Recapitulation",
      analisis_pegawai_desc: "Workforce composition: employment status (PNS/PPPK/Contract), medical vs non-medical staff, and distribution per unit.",
      siperkasa_overline: "SIPERKASA • Restricted Area",
      siperkasa_title: "Hospital Performance Measurement Information System",
      siperkasa_subtitle:
        "Improving performance monitoring & evaluation at RS Bhayangkara Tingkat IV Tarakan through integrated tracking of key indicators across all work units.",
      siperkasa_sources: "Performance Data Sources",
      siperkasa_penunjang: "Supporting Facilities",
      analisis_lab_title: "Laboratory — Visits",
      analisis_lab_desc: "Number of lab tests by type (hematology, clinical chemistry, microbiology, etc.).",
      analisis_radiologi_title: "Radiology — Visits",
      analisis_radiologi_desc: "Number of radiology exams by modality (X-Ray, USG, CT-Scan, ECG).",
      analisis_apotek_title: "Pharmacy — Visits & Medicine",
      analisis_apotek_desc: "Number of prescriptions per service unit and medicine usage recap.",
      apotek_resep_total: "Total Prescriptions",
      apotek_resep_breakdown: "Prescriptions by Service Unit",
      apotek_obat_title: "Medicine Usage Recapitulation",
      apotek_obat_total: "Total Medicine Items Dispensed",
      apotek_obat_top: "Top 10 Most-Used Medicines",
      apotek_obat_kategori: "Medicine Category Composition",
      penunjang_breakdown: "Examination Breakdown",
      siperkasa_pegawai_total: "Total Employees",
      siperkasa_by_status: "Employment Status Composition",
      siperkasa_by_type: "Medical vs Non-Medical Staff",
      siperkasa_by_unit: "Employee Distribution by Unit",
      siperkasa_by_gender: "Gender Composition",
      siperkasa_headcount_trend: "Headcount Trend",
      analisis_locked: "Please log in to access analytics",
      analisis_login_cta: "Admin Login",
      breakdown_poli: "Visits per Clinic",
      breakdown_ralan: "Outpatient Visits per Clinic",
      breakdown_ranap: "Inpatient Visits per Ward",
      pasien_baru: "New",
      pasien_lama: "Returning",
      pasien: "patients",
      rasio_baru_lama: "New vs Returning Patient Ratio",
      rasio_baru_lama_desc: "Outpatient acquisition indicator",
      ralan_table_title: "Outpatient Detail per Clinic",
      col_poli: "Clinic",
      trend_baru_title: "New Patient Percentage Trend",
      trend_ranap_title: "Inpatient Occupancy Trend per Ward",
      bor_bangsal_title: "BOR per Ward (This Month)",
      bor_bangsal_top: "Most crowded",
      bor_bangsal_hint: "Green = within target, amber = below, red = above Kemenkes target",
      bor_bangsal_trend_title: "BOR Trend per Ward",
      top_poli_badge: "Highest",
      top_poli_label: "Clinic with the highest new-patient proportion",
      top_bangsal_label: "Ward with the highest new-patient proportion",
      rasio_baru_ranap: "New vs Returning Inpatient Ratio",
      rasio_baru_ranap_desc: "Inpatient acquisition indicator",
      total_ralan: "Total Outpatient",
      total_ranap: "Total Inpatient",
      weekday_pattern: "Weekday Pattern",
      yoy_growth: "YoY Growth",
      last_year: "Last Year",
      this_year: "This Year",
      bor_indicator: "BOR Indicator",
      admissions: "Admissions",
      discharges: "Discharges",
      deaths: "Deaths",
      beds_total: "Total Beds",
      target_range: "Target Range",
      ind_bor_desc: "Bed utilisation efficiency",
      ind_los_desc: "Average length of stay",
      ind_toi_desc: "Average bed idle days between patients",
      ind_bto_desc: "Bed turnover frequency",
      status_above: "Above target",
      status_under: "Below target",
      mutu_title: "Quality Card — Mortality Rate",
      mutu_ndr: "NDR (Net Death Rate)",
      mutu_gdr: "GDR (Gross Death Rate)",
      mutu_ndr_desc: "Deaths ≥ 48h per 1,000 discharges",
      mutu_gdr_desc: "Total deaths per 1,000 discharges",
      mutu_target: "MoH Target",
      mutu_no_data: "No discharge data yet",
      mutu_deaths_total: "Total deaths",
    },
  },
};

export const HOSPITAL = {
  name: "RS Bhayangkara Tarakan",
  affiliation: "Polda Kalimantan Utara",
  phone_display: "+62 822 4176 1118",
  whatsapp: "6282241761118",
  email: "kontak@rsbhayangkaratarakan.id",
  address_id: "Jalan Karya Bersama RT 18, Kelurahan Juata Laut, Kecamatan Tarakan Utara, Kota Tarakan, Kalimantan Utara 77146",
  address_en: "Jalan Karya Bersama RT 18, Juata Laut, North Tarakan, Tarakan City, North Kalimantan 77146",
  logo: "/logo.jpg",
  instagram_handle: "rumahsakitbhayangkaratarakan",
  instagram_url: "https://www.instagram.com/rumahsakitbhayangkaratarakan",
  facebook_url: "https://www.facebook.com/profile.php?id=61550913542695",
};

export const whatsappLink = (message = "") => {
  const base = `https://wa.me/${HOSPITAL.whatsapp}`;
  return message ? `${base}?text=${encodeURIComponent(message)}` : base;
};
